import { useState } from "react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Plus, Pencil, Trash2, Check, X } from "lucide-react";
import { toast } from "sonner";

const empty = { name: "", contact_name: "", phone: "", address: "", note: "" };
const fields = [["name", "Müşteri adı *"], ["contact_name", "Yetkili"], ["phone", "Telefon"], ["address", "Adres / Şehir"], ["note", "Not"]];

export default function FairCustomers({ customers, orders, onChanged }) {
  const [form, setForm] = useState(empty);
  const [editing, setEditing] = useState(null);

  const save = async () => {
    try {
      if (editing) await api.put(`/fair/customers/${editing}`, form);
      else await api.post("/fair/customers", form);
      toast.success(editing ? "Müşteri güncellendi" : "Müşteri eklendi");
      setForm(empty); setEditing(null); onChanged();
    } catch (e) { toast.error(e.response?.data?.detail || "Hata"); }
  };
  const remove = async (c) => {
    if (!window.confirm(`${c.name} silinsin mi?`)) return;
    try { await api.delete(`/fair/customers/${c.id}`); toast.success("Silindi"); onChanged(); }
    catch (e) { toast.error(e.response?.data?.detail || "Silinemedi"); }
  };

  return (
    <div className="space-y-5" data-testid="fair-customers">
      <section className="rounded-lg border border-[#DCCFB8] bg-[#FFFBF4] p-5">
        <h2 className="font-display text-lg font-bold uppercase tracking-tight mb-3">{editing ? "Müşteriyi Düzenle" : "Yeni Fuar Müşterisi"}</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3">
          {fields.map(([f, ph]) => (
            <Input key={f} placeholder={ph} value={form[f]} data-testid={`fair-customer-${f}`}
              onChange={(e) => setForm({ ...form, [f]: e.target.value })} className="h-11 bg-[#EFE6D6] border-[#DCCFB8]" />
          ))}
        </div>
        <div className="flex gap-2 mt-3">
          <Button onClick={save} data-testid="fair-customer-save" className="h-10 bg-[#D97706] hover:bg-[#B45309] text-white">
            {editing ? <><Check className="w-4 h-4 mr-1" /> Kaydet</> : <><Plus className="w-4 h-4 mr-1" /> Ekle</>}</Button>
          {editing && <Button variant="outline" onClick={() => { setEditing(null); setForm(empty); }} data-testid="fair-customer-cancel"
            className="h-10 border-[#DCCFB8] bg-transparent"><X className="w-4 h-4" /></Button>}
        </div>
        <p className="text-xs text-[#8C7B68] mt-2">Fuar müşterileri ana müşteri listesinden tamamen ayrıdır.</p>
      </section>
      {customers.length === 0 && <div className="rounded-lg border border-[#DCCFB8] bg-[#FFFBF4] p-8 text-center text-[#8C7B68]" data-testid="fair-customers-empty">Henüz fuar müşterisi yok.</div>}
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3">
        {customers.map((c) => {
          const os = orders.filter((o) => o.customer_id === c.id);
          return (
            <div key={c.id} className="rounded-lg border border-[#DCCFB8] bg-[#FFFBF4] p-4" data-testid={`fair-customer-card-${c.id}`}>
              <div className="flex items-start justify-between">
                <div className="min-w-0">
                  <p className="font-display text-lg font-bold truncate">{c.name}</p>
                  <p className="text-xs text-[#6B5B4A]">{[c.contact_name, c.phone, c.address].filter(Boolean).join(" · ") || "—"}</p>
                </div>
                <span className="flex gap-2 shrink-0">
                  <button onClick={() => { setEditing(c.id); setForm({ ...empty, ...c }); }} data-testid={`fair-customer-edit-${c.id}`}
                    className="text-[#8C7B68] hover:text-[#B45309]"><Pencil className="w-4 h-4" /></button>
                  <button onClick={() => remove(c)} data-testid={`fair-customer-delete-${c.id}`} className="text-[#8C7B68] hover:text-[#EF4444]"><Trash2 className="w-4 h-4" /></button>
                </span>
              </div>
              <p className="text-[11px] font-mono uppercase text-[#B45309] mt-2">{os.length} sipariş · {os.reduce((a, o) => a + o.items.reduce((x, i) => x + i.koli, 0), 0)} koli</p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
